<template>
  <div class="inplace-editor">
    <div class="label subtitle-2" v-if="showLabel" @click="handleOnlick">{{ label }}</div>
    <div
      ref="input-element"
      class="editable"
      :class="size === 'small' ? 'body-2' : 'heading'"
      v-select-on-focus
      @blur="onBlur"
      contenteditable="true"
      @keydown="onKeyDownHandler"
      :data-placeholder="label"
    ></div>
  </div>
</template>

<script>
import selectOnFocus from 'vue-select-on-focus'

export default {
  name: 'InplaceEditor',
  directives: {
    selectOnFocus,
  },
  props: {
    id: String,
    value: String,
    label: String,
    type: String,
    size: {
      type: String,
      default: 'small',
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      internalValue: '',
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.$nextTick(() => {
          this.internalValue = newVal
          this.$refs['input-element'].innerText = this.internalValue
        })
      },
    },
  },
  computed: {
    hasValue() {
      return this.internalValue.trim().length > 0
    },
  },
  methods: {
    handleOnlick() {
      this.$refs['input-element'].focus()
    },
    onBlur(e) {
      const newVal = e.target.innerText.trim()
      if (this.value !== newVal) this.$emit('input', e.target.innerText)
    },
    onKeyDownHandler(e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault()
        e.stopPropagation()
        this.$emit('input', e.target.innerText)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.inplace-editor {
  display: flex;
  align-items: baseline;
}
.label {
}
.editable {
  padding: 2px 4px;
  cursor: text;
  margin-left: 2px;
  overflow-x: auto;
}
.editable:empty:before {
  content: attr(data-placeholder);
  color: #aaa;
}
.heading {
  font-size: 1.3rem;
  font-weight: 500;
}
</style>
